import React, { useState, useEffect } from 'react';
import { getPlanOptions } from '../utils/api';

export default function PlanUpgradeBanner() {
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await getPlanOptions();
        setOptions(res.data.data);
      } catch (err) {
        console.warn('[PlanUpgradeBanner] failed to load plan options:', err?.message);
        setOptions(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return (
    <>
      <style>{`@keyframes lcSpin{to{transform:rotate(360deg)}}`}</style>
      <div style={{ padding: '16px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ width: 18, height: 18, border: '2px solid #4F46E5',
                      borderTopColor: 'transparent', borderRadius: '50%',
                      animation: 'lcSpin 0.8s linear infinite' }} />
        <span style={{ fontSize: 12, color: '#888' }}>Loading plan...</span>
      </div>
    </>
  );
  if (!options) return null;

  const { currentPlan, upgradePlans } = options;
  const planName = currentPlan?.planName;

  if (planName === 'SCALE' || upgradePlans?.length === 0) {
    return (
      <div style={s.wrapper}>
        <p style={s.bestPlan}>You are on the best plan. Thank you!</p>
      </div>
    );
  }
  if (!['FREE', 'STARTER', 'AI_ADMIN', 'SOLO_FREE', 'SOLO_PLUS', 'SOLO_PRO', 'SOLO_AI_ADMIN'].includes(planName)) return null;

  return (
    <div style={s.wrapper}>
      <div style={s.currentRow}>
        <span style={s.yourPlanLabel}>Your plan</span>
        <span style={s.planBadge}>{planName}</span>
        {currentPlan.featureSummary && (
          <span style={s.planLimits}>{currentPlan.featureSummary}</span>
        )}
      </div>
      {upgradePlans.length > 0 && (
        <>
          <div style={s.upgradeLabel}>Upgrade to grow your centre:</div>
          <div style={s.cardsRow}>
            {upgradePlans.map(plan => (
              <div key={plan.planName} style={{ ...s.card, ...(plan.highlight ? s.cardRec : {}) }}>
                {plan.highlight && <div style={s.recBadge}>★ RECOMMENDED</div>}
                <div style={s.planName}>{plan.planName.replace(/_/g, ' ')}</div>
                <div style={s.price}>
                  {(plan.gstInclusivePrice ?? plan.monthlyPriceINR) != null
                    ? `₹${(plan.gstInclusivePrice ?? plan.monthlyPriceINR).toLocaleString('en-IN')}/mo`
                    : 'Contact us'}
                </div>
                {plan.featureSummary && <div style={s.limits}>{plan.featureSummary}</div>}
                {plan.roiMessage     && <div style={s.roiMsg}>{plan.roiMessage}</div>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const s = {
  wrapper:      { background: '#050A1A', borderRadius: 12, padding: '20px 24px',
                  marginBottom: 24, color: '#fff' },
  currentRow:   { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                  marginBottom: 16 },
  yourPlanLabel:{ fontSize: 12, color: 'rgba(255,255,255,0.55)',
                  textTransform: 'uppercase', letterSpacing: '1px' },
  planBadge:    { background: '#0D9488', color: '#fff', borderRadius: 20,
                  padding: '3px 12px', fontSize: 12, fontWeight: 700 },
  planLimits:   { fontSize: 13, color: 'rgba(255,255,255,0.45)' },
  upgradeLabel: { fontSize: 13, color: 'rgba(255,255,255,0.45)',
                  marginBottom: 16, letterSpacing: '0.5px' },
  cardsRow:     { display: 'flex', gap: 12, flexWrap: 'wrap' },
  card:         { flex: '1 1 160px', background: '#0D1330', borderRadius: 8,
                  padding: 16, border: '1px solid rgba(255,255,255,0.08)' },
  cardRec:      { border: '2px solid #4F46E5', background: '#0F1642' },
  recBadge:     { fontSize: 10, fontWeight: 700, color: '#D4A520',
                  letterSpacing: '1px', marginBottom: 8 },
  planName:     { fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 4 },
  price:        { fontSize: 20, fontWeight: 800, color: '#fff', marginBottom: 8 },
  limits:       { fontSize: 12, color: 'rgba(255,255,255,0.55)', marginBottom: 8 },
  roiMsg:       { fontSize: 11, color: '#D4A520', fontStyle: 'italic' },
  bestPlan:     { textAlign: 'center', color: '#D4A520', fontSize: 15,
                  fontWeight: 600, margin: 0 },
};
